<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="payOrderForm" :model="payOrderForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="下单时间">
                <el-date-picker clearable
                                v-model="payOrderForm.createTime"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                               >
                </el-date-picker>
              </el-form-item>
            </el-col>
         
          
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="订单号">
                <el-input v-model="payOrderForm.orderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="外部订单号">
                <el-input v-model="payOrderForm.openOrderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-button type="primary" @click="getPayOrderList">查询</el-button>
            <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
         </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="openOrderNo"
            label="外部订单号">
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="hjxPrice"
            label="换机侠出价">
          </el-table-column>
          <el-table-column
            prop="price"
            label="回收宝出价">
          </el-table-column>
          <el-table-column
            prop="quoteTime"
            label="报价时间">
          </el-table-column>
          <el-table-column
            prop="finalPrice"
            label="最终报价">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === '0'">竞价中</span>
              <span v-else-if="scope.row.status === '1'">未中标</span>
              <span v-else-if="scope.row.status === '2'" style="color: red;">已中标</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      payOrderForm: {
      },
      categoryOptions: [],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editpayOrderForm: {
        id: null,
        type: 1
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        // tempGradeIdList: [
        //   { required: true, message: '请选择前端等级', trigger: 'change' },
        // ],
        autoPriceGradeId: [
          { required: true, message: '请选择出价等级', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      queryGradeList:[]
    }
  },
  watch:{},
  computed:{},
  methods:{
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getPayOrderList()
    }, 

      // click事件
    exportExcelData () {
      let self  = this;
      self.payOrderForm.page=self.currentPage;
      self.payOrderForm.size=self.pageSize;
      self.payOrderForm.createTimeStart = self.payOrderForm.createTime instanceof Array && self.payOrderForm.createTime.length > 1 ? self.payOrderForm.createTime[0] + ' 00:00:00' : null,
      self.payOrderForm.createTimeEnd = self.payOrderForm.createTime instanceof Array && self.payOrderForm.createTime.length > 1 ? self.payOrderForm.createTime[1] + ' 23:59:59' : null,
      self.$api.exportHsbQuotePriceInfo(self.payOrderForm).then((res) => {
        var downLoadTableData = res.data || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["外部订单号","订单号","换机侠出价","回收宝出价","报价时间","最终报价","状态"];
                const filterVal = ["openOrderNo","orderNo",  "hjxPrice", "price", "quoteTime", "finalPrice","status"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                        if(j=="status"){
                          return v[j]=="0"?"竞价中":(v[j]=="1"?"未中标":"已中标")
                        }else{
                          return v[j]
                        }    
                }
                 ));
                export_json_to_excel(fieldName, data, "回收宝出价记录"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
      });
    },

    // 获取门店列表
    getPayOrderList() {
      let self  = this;
      self.payOrderForm.page=self.currentPage;
      self.payOrderForm.size=self.pageSize;
      self.payOrderForm.createTimeStart = self.payOrderForm.createTime instanceof Array && self.payOrderForm.createTime.length > 1 ? self.payOrderForm.createTime[0] + ' 00:00:00' : null,
      self.payOrderForm.createTimeEnd = self.payOrderForm.createTime instanceof Array && self.payOrderForm.createTime.length > 1 ? self.payOrderForm.createTime[1] + ' 23:59:59' : null,
      self.$api.listSearchHsbQuotePriceInfo(self.payOrderForm).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addAlipyAccount() {
      this.dlgType = 'new'
      this.editpayOrderForm =  {
        id: null,
        type: "1"
      }
      this.$nextTick(()=>{
          this.$refs['editpayOrderForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorAlipyAccount(row) {
      let self = this;
      self.editpayOrderForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editpayOrderForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateAlipyAccount(self.editpayOrderForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getPayOrderList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addAlipyAccount(self.editpayOrderForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getPayOrderList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 开启门店
    pushPayOrder(id) {
      let self = this
      this.$api.pushPayOrder(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          self.getPayOrderList()
        }
      })
    },

    // 关闭门店
    paySuccessAndPush(row) {
      let self = this
      this.$confirm('将订单'+row.orderNo+'修改为已支付并重新推送, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.paySuccessAndPush(row.id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          self.getPayOrderList()
        }
      })
        }).catch(() => {          
        });
      
    },
     // 关闭门店
     waitPay(row) {
      let self = this
      self.$confirm('将订单'+row.orderNo+'重置为待付款状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.$api.waitPay(row.id).then(res => {
            if(res.code === 200) {
              self.$message({
                message: '操作成功',
                type: 'success'
              });
              self.getPayOrderList()
            }
          })
        }).catch(() => {        
        });
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getPayOrderList();
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>